export var ERememberedAccountType;

(function (ERememberedAccountType) {
  ERememberedAccountType["Phone"] = "phone";
  ERememberedAccountType["Email"] = "email";
})(ERememberedAccountType || (ERememberedAccountType = {}));